var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crumbsNavCont"},[_c('p',{staticClass:"crumbsNav"},[_vm._v("位置："),_c('router-link',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(">"+_vm._s(_vm.curPageName))],1),_vm._v(" "),_c('div',{staticClass:"searchBox"},[_c('search')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53178204","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/positionNav.vue
// module id = null
// module chunks = 